import React from 'react'
import Link from 'gatsby-link'
import ClassNames from 'classnames'
import scrollTo from 'gatsby-plugin-smoothscroll'

class Intro extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Buy-Intro">
        <div className="internal">
          {/*<div className="Buy-Intro" dangerouslySetInnerHTML={{ __html: this.props.buyIntro.replace(/\n/g,"<br />") }}></div>*/}
          <p>It’s the only tablet that transforms water into a fitness drink that warms up your body and mind for yoga. So you have a more relaxing and invigorating practice.</p>
          <p>Yoga Flow will give you:</p>
          <ul>
            <li>more stamina - do more poses, even the tough ones</li>
            <li>better focus - leave yoga feeling fully recharged</li>
            <li>less joint stiffness and more flexibility - go deeper into poses without needing extra practice time</li>
            <li>full hydration - feel restored and refreshed after sweaty and powerful sessions</li>
          </ul>
          <p>It removes the obstacles that keep you from getting full value out of every session.<br/> (We dedicate it to Patanjali 🧘🏽)</p>
          <a onClick={() => scrollTo('#BuyNow')} className="Btn orange-white">{this.props.callToAction}</a>
        </div>
      </div>
    );
  }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/buy/intro.js